import React from "react";

const CPP_For_Loop = () => {
  return (
    <div>
      <h1>CPP_For_Loop Component</h1>
      <p>Content for CPP_For_Loop goes here...</p>
    </div>
  );
};

export default CPP_For_Loop;
